import _ from "lodash";

import {
  MERCHANT_ORDER_LIST_REQUEST,
  MERCHANT_ORDER_LIST_SUCCESS,
  MERCHANT_ORDER_LIST_FAIL,
  MERCHANT_ORDER_READ_REQUEST,
  MERCHANT_ORDER_READ_SUCCESS,
  MERCHANT_ORDER_READ_FAIL,
  MERCHANT_ORDER_ACCEPT_REQUEST,
  MERCHANT_ORDER_ACCEPT_SUCCESS,
  MERCHANT_ORDER_ACCEPT_FAIL,
  MERCHANT_ORDER_ACCEPT_RESET,
  ADMIN_ORDER_LIST_REQUEST,
  ADMIN_ORDER_LIST_SUCCESS,
  ADMIN_ORDER_LIST_FAIL,
  MERCHANT_ORDER_SHIPMENT_REQUEST,
  MERCHANT_ORDER_SHIPMENT_SUCCESS,
  MERCHANT_ORDER_SHIPMENT_FAIL,
  MERCHANT_ORDER_READ_RESET,
  ADMIN_ORDER_STATUS_CHANGE_REQUEST,
  ADMIN_ORDER_STATUS_CHANGE_SUCCESS,
  ADMIN_ORDER_STATUS_CHANGE_FAIL,
  ADMIN_ORDER_UPDATE_REQUEST,
  ADMIN_ORDER_UPDATE_SUCCESS,
  ADMIN_ORDER_UPDATE_FAIL,
  ADMIN_ALLORDERSLIST_FAIL,
  ADMIN_ALLORDERSLIST_REQUEST,
  ADMIN_ALLORDERSLIST_SUCCESS,
  ADMIN_SINGLEORDER_FAIL,
  ADMIN_SINGLEORDER_REQUEST,
  ADMIN_SINGLEORDER_SUCCESS,
  ADMIN_ALLORDER_SEARCH_FAIL,
  ADMIN_ALLORDER_SEARCH_REQUEST,
  ADMIN_ALLORDER_SEARCH_SUCCESS,
  ADMIN_SINGLEORDER_SEARCH_FAIL,
  ADMIN_SINGLEORDER_SEARCH_REQUEST,
  ADMIN_SINGLEORDER_SEARCH_SUCCESS,
  ADMIN_SINGLEORDER_MESSAGELOG_ADD_FAIL,
  ADMIN_SINGLEORDER_MESSAGELOG_ADD_REQUEST,
  ADMIN_SINGLEORDER_MESSAGELOG_ADD_SUCCESS,
} from "./ordersTypes";

export const orderListReducer = (state = {}, action) => {
  switch (action.type) {
    // REQUEST
    case MERCHANT_ORDER_LIST_REQUEST || MERCHANT_ORDER_ACCEPT_REQUEST:
      return { ...state, loading: true };

    // FAILED
    case MERCHANT_ORDER_LIST_FAIL || MERCHANT_ORDER_READ_FAIL || MERCHANT_ORDER_ACCEPT_FAIL:
      return { ...state, loading: false, error: action.payload };

    // LIST
    case MERCHANT_ORDER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orderProducts: action.payload.orderProducts,
        orderProductsCount: action.payload.totalOrderProductsCount,
      };

    // READ
    case MERCHANT_ORDER_READ_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MERCHANT_ORDER_READ_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        singleOrder: action.payload,
      };
    case MERCHANT_ORDER_READ_RESET:
      return {
        ...state,
        success: false,
        // singleOrder: action.payload,
      };

    // ACCEPT
    case MERCHANT_ORDER_ACCEPT_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case MERCHANT_ORDER_ACCEPT_RESET:
      return {
        ...state,
        loading: false,
      };
    // SHIPMENT
    case MERCHANT_ORDER_SHIPMENT_REQUEST:
      return { ...state, loading: true };
    case MERCHANT_ORDER_SHIPMENT_SUCCESS:
      return { ...state, loading: false, singleOrderSuccess: action.payload };
    case MERCHANT_ORDER_SHIPMENT_FAIL:
      return { ...state, loading: false, error: action.payload };

    // ADMIN
    case ADMIN_ORDER_LIST_REQUEST:
      return { ...state, loading: true };
    case ADMIN_ORDER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orderProducts: action.payload.orderProducts,
        orderProductsCount: action.payload.totalOrderProductCount,
      };
    case ADMIN_ORDER_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_ALLORDERSLIST_REQUEST:
      return { ...state, loading: true };
    case ADMIN_ALLORDERSLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.filter
          ? action.payload.allOrders.filter(
              (el) => el.orderBy?.address?.state === action.payload.filter
            )
          : action.payload.allOrders,
        ordersCount: action.payload.totalOrdersCount,
      };
    case ADMIN_ALLORDERSLIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_SINGLEORDER_REQUEST:
      return { ...state, loading: true };
    case ADMIN_SINGLEORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        order: action.payload,
      };
    case ADMIN_SINGLEORDER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_SINGLEORDER_MESSAGELOG_ADD_REQUEST:
      return { ...state, loadingLog: true };

    case ADMIN_SINGLEORDER_MESSAGELOG_ADD_SUCCESS:
      return {
        ...state,
        loadingLog: false,
        singleOrder: action.payload,
      };
    case ADMIN_SINGLEORDER_MESSAGELOG_ADD_FAIL:
      return { ...state, loadingLog: false, error: action.payload };

    // change status
    case ADMIN_ORDER_STATUS_CHANGE_REQUEST:
      return { ...state, loading: true };
    case ADMIN_ORDER_STATUS_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        updated: "success",
      };
    case ADMIN_ORDER_STATUS_CHANGE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // update
    case ADMIN_ORDER_UPDATE_REQUEST:
      return { ...state, loading: true };
    case ADMIN_ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updated: "success",
      };
    case ADMIN_ORDER_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_SINGLEORDER_SEARCH_REQUEST:
      return {
        ...state,
        searchLoading: true,
      };

    case ADMIN_SINGLEORDER_SEARCH_SUCCESS:
      return {
        ...state,
        searchLoading: false,
        orderProducts: [action.payload],
        orderProductsCount: 0,
        searchSuccess: true,
      };

    case ADMIN_SINGLEORDER_SEARCH_FAIL:
      return {
        ...state,
        searchLoading: false,
        searchError: action.payload,
        orderProducts: [],
        orderProductsCount: 0,
        searchSuccess: false,
      };

    case ADMIN_ALLORDER_SEARCH_REQUEST:
      return {
        ...state,
        searchLoading: true,
      };

    case ADMIN_ALLORDER_SEARCH_SUCCESS:
      return {
        ...state,
        searchLoading: false,
        orders: [action.payload],
        ordersCount: 0,
        searchSuccess: true,
      };

    case ADMIN_ALLORDER_SEARCH_FAIL:
      return {
        ...state,
        searchLoading: false,
        searchError: action.payload,
        orders: [],
        ordersCount: 0,
        searchSuccess: false,
      };
    default:
      return state;
  }
};
